import { FC } from 'react';
import { TaskCenterTypes } from '@frontend/api-task-center';
import { Icon } from '@frontend/icons';
import { type SelectedFilters } from '@frontend/task-center-scope';
import { Avatar } from '@frontend/design-system';
import { callIntelIconStyle } from './task-item.styles';

interface TaskAIIconProps {
  source: TaskCenterTypes.TaskSource;
  creator?: SelectedFilters['creator'];
  isAIRCreatorEnabled: boolean;
}

export const TaskAIIcon: FC<TaskAIIconProps> = ({ source, creator, isAIRCreatorEnabled }) => {
  if (source === TaskCenterTypes.TaskSource.SOURCE_CALL_INTELLIGENCE) {
    return (
      <Icon
        name='aiassistant-small'
        css={callIntelIconStyle(isAIRCreatorEnabled ? !!creator && 'air' in creator : false)}
      />
    );
  } else if (
    source === TaskCenterTypes.TaskSource.SOURCE_MESSAGING &&
    isAIRCreatorEnabled &&
    creator &&
    'air' in creator
  ) {
    return <Avatar size='xs' name='' isAiAssistant css={callIntelIconStyle(false)} />;
  }
  return null;
};
